package com.essntl.features.itinerary.domain.model

data class ItineraryToConfirmModel(
    val id: String,
    val createdAt: String,
    val title: String,
    val ownerName: String,
    val ownerId: String,
    val fromDate: String,
    val toDate: String,
    val unconfirmedServiceCount: Int,
    val totalServices: Int,
    val clientName: String,
)
